import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M2.34 6.32999V17.67H21.675V6.32999H2.34ZM19.665 15.66H4.335V8.33999H19.665V15.66ZM17.01 10.995H7.005V12.99H17.01V10.995Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.89957 3.10054C4.67893 2.8799 4.32119 2.8799 4.10054 3.10054L2.10054 5.10054C1.8799 5.32119 1.8799 5.67893 2.10054 5.89957C2.32119 6.12022 2.67893 6.12022 2.89957 5.89957L3.93506 4.86409V10.1359L2.89957 9.10043C2.67893 8.87978 2.32119 8.87978 2.10054 9.10043C1.8799 9.32107 1.8799 9.67881 2.10054 9.89946L4.10054 11.8995C4.32119 12.1201 4.67893 12.1201 4.89957 11.8995L6.89957 9.89946C7.12022 9.67881 7.12022 9.32107 6.89957 9.10043C6.67893 8.87978 6.32119 8.87978 6.10054 9.10043L5.06506 10.1359V4.86409L6.10054 5.89957C6.32119 6.12022 6.67893 6.12022 6.89957 5.89957C7.12022 5.67893 7.12022 5.32119 6.89957 5.10054L4.89957 3.10054ZM8.50006 2.93506C8.18802 2.93506 7.93506 3.18802 7.93506 3.50006C7.93506 3.8121 8.18802 4.06506 8.50006 4.06506H13.5001C13.8121 4.06506 14.0651 3.8121 14.0651 3.50006C14.0651 3.18802 13.8121 2.93506 13.5001 2.93506H8.50006ZM8.50006 10.9351C8.18802 10.9351 7.93506 11.188 7.93506 11.5001C7.93506 11.8121 8.18802 12.0651 8.50006 12.0651H13.5001C13.8121 12.0651 14.0651 11.8121 14.0651 11.5001C14.0651 11.188 13.8121 10.9351 13.5001 10.9351H8.50006ZM7.93506 7.50006C7.93506 7.18802 8.18802 6.93506 8.50006 6.93506H13.5001C13.8121 6.93506 14.0651 7.18802 14.0651 7.50006C14.0651 7.8121 13.8121 8.06506 13.5001 8.06506H8.50006C8.18802 8.06506 7.93506 7.8121 7.93506 7.50006Z"
  />
);

export const CutTextMIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="CutTextM" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
